import { version } from '../../../../package.json';

/**
 * Versão exibida na aplicação. Vem do package.json porque é ele que o release-please
 * incrementa a cada release (ver o commit "chore: release x.y.z"), então isto acompanha
 * a tag sozinho — nada de número duplicado num arquivo que alguém esquece de atualizar.
 * O caminho feio até a raiz mora só aqui.
 */
export const APP_VERSION: string = version;
